const sections = document.querySelectorAll('.js-homeSection');
const targetIds = ['js-cta', 'js-contents', 'js-footer'];
const visibilityMap = {
  cta: false,
  contents: false,
  footer: false
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const id = entry.target.id;
    visibilityMap[id] = entry.isIntersecting;
  });

  const anyVisible = Object.values(visibilityMap).some(visible => visible);

  sections.forEach(section => {
    section.classList.toggle('-disable', anyVisible);
  });
}, {
  threshold: 0.01,
  rootMargin: '0px 0px -10% 0px'
});

targetIds.forEach(id => {
  const el = document.getElementById(id);
  if (el) observer.observe(el);
});
